export const optionsRulesSelect = [
    { value: "title", name: "Título" },
    { value: "subtitle", name: "Subtítulo" },
    { value: "listitem", name: "Item de lista" },
    { value: "paragraph", name: "Párrafo" },
    { value: "link", name: "Enlace" },
  ];